import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { NbDialogService } from '@nebular/theme';
import { CharacterEditModalComponent } from './edit/character-edit-modal.component';
import { CharacterChangesModalComponent } from './changes/character-changes-modal.component';
import { ConfirmModalComponent } from '../modals/confirm-modal.component';

import { MissionService, GameService, TemplateService, CharacterService, LanguageService, MediaService } from '../../_services/index';
import { Character } from '../../classes';

import { take } from 'rxjs/operators';

@Component({
    selector: 'app-edit-characters-param',
    templateUrl: './edit-characters.component.html',
    styleUrls: ['./edit-characters.component.scss'],
    standalone: false
})

export class EditCharactersComponent {

  characters = [];
  characterSubscriber;
  
  gameId;
  game;
  templateId;
  template;

  games;

  medias = [];
  mediaSubscriber;

  constructor(private route: ActivatedRoute,
    public characterService: CharacterService,
    public gameService: GameService,
    public missionService: MissionService,
    public mediaService: MediaService,
    public templateService: TemplateService,
    private dialogService: NbDialogService,
    public languageService: LanguageService) {
      this.route
      .params
      .subscribe(params => {
        // Récupération des valeurs de l'URL
        console.log('params:'+JSON.stringify(params));
        this.gameId = params['id'];
        this.templateId = params['templateId'];
        console.log('Load data - gameId:'+this.gameId+', templateId:'+this.templateId);
        
        if(this.characterSubscriber){
          this.characterSubscriber.unsubscribe();
        }
        if(this.mediaSubscriber){
          this.mediaSubscriber.unsubscribe();
        }
        if(this.gameId){
          this.gameService.getGame(this.gameId)
          .subscribe(game => {
            if(game){
              this.game = game;
              if(game.templateId){
                this.templateId = game.templateId;
              }
            }
          });
          this.characterSubscriber = this.characterService.listCharacters(`games/${this.gameId}/characters`)
          .subscribe(characters => {;
            if(characters){
              this.characters = this.sort(characters);
              if(!this.isOrdered(this.characters)) {
                this.setOrder(this.characters);
                this.saveOrder(this.characters);
              }
            }
          });
          this.mediaSubscriber = this.mediaService.listMedias(`games/${this.gameId}/medias`)
          .subscribe(medias => {;
            this.medias = medias;
          });
        }
        else if(this.templateId){
          this.templateService.getTemplate(this.templateId)
          .subscribe(template => {
            if(template){
              this.template = template;
            }
          });
          this.characterSubscriber = this.characterService.listCharacters(`game_templates/${this.templateId}/characters`)
          .subscribe(characters => {
            if(characters){
              this.characters = this.sort(characters);
              if(!this.isOrdered(this.characters)) {
                this.setOrder(this.characters);
                this.saveOrder(this.characters);
              }
            }
          });
          this.mediaSubscriber = this.mediaService.listMedias(`game_templates/${this.templateId}/medias`)
          .subscribe(medias => {;
            this.medias = medias;
          });
        }
      });
  }

  isOrdered(objects) {
    let exist = true
    for (let i = 0; i < objects.length; i++) {
      if (!objects[i]?.orderNum) {
        exist = false;
      }
    }
    return exist;
  }

  setOrder(characters){
    for (let j = 0; j < characters.length; j++) {
      characters[j].orderNum = j+1;
    }
  }

  sort(characters){
    return characters.sort((x, y) => x.orderNum - y.orderNum);
  }

  changePosition(old_index, new_index){
    this.characters[old_index].orderNum = new_index
    this.characters[new_index].orderNum = old_index
    
    this.saveOrderCharacter(this.characters[old_index])
    this.saveOrderCharacter(this.characters[new_index])
    this.characters = this.sort(this.characters);
  }

  saveOrder(characters){
    for (const char of characters) {
      this.saveOrderCharacter(char)
    }
  }

  async saveOrderCharacter(char){
    await this.characterService.setCharacter(char).then(value => {
    }, err => {
      console.log('err :', err)
    });
  }
  
  
  applyChanges(){
    this.gameService.listTemplateGames(this.template.id)
    .pipe(take(1))
    .subscribe(async games => {
      this.games = games;
      this.dialogService.open(CharacterChangesModalComponent, { 
        context: {
          data : {
            currentLang:this.languageService.currentLang,
            games: this.games,
            templateId:this.templateId,
            templateCharacters:this.characters
          }
        },
      })
      .onClose.subscribe(async res => {
        console.log('Dialog returns:'+res);
        if(res){
        }
      });
    })
  }

  ngOnInit() {
  }

  editCharacter(char){
    if(this.gameId){
      if(!char){
        char = new Character(`games/${this.game.id}/characters`);
        char.gameId = this.gameId;
        char.orderNum = this.characters.length+1;
      }
      this.dialogService.open(CharacterEditModalComponent, { 
        context: {
          model: char,
          game: this.game,
          gameId: this.gameId,
          templateId: this.templateId,
          languages: this.game.workingLanguages
        }, closeOnBackdropClick: false
      })
      .onClose.subscribe(res => {
        console.log('Dialog returns:'+res);
      });
    } else {
      if(!char){
        char = new Character(`game_templates/${this.templateId}/characters`);
        char.templateId = this.templateId;
        char.orderNum = this.characters.length+1;
      }
      this.dialogService.open(CharacterEditModalComponent, { 
        context: {
          model: char,
          game: this.template,
          gameId: this.gameId,
          templateId: this.templateId,
          languages: this.template.workingLanguages
        }, closeOnBackdropClick: false
      })
      .onClose.subscribe(res => {
        console.log('Dialog returns:'+res);
      });
    }
  }

  deleteCharacter(char){
    this.dialogService.open(ConfirmModalComponent, { 
      context: {
        title: 'Confirmation',
        message: `Do you want to delete character '`+char.labels[this.languageService.currentLang]+`'?`
      }, closeOnBackdropClick: false
    })
    .onClose.subscribe(async res => {
      console.log('Dialog returns:'+res);
      if(res){
        console.log('Delete mission');
        await this.characterService.deleteCharacter(char);
        this.setOrder(this.characters);
        this.saveOrder(this.characters);
      }
    });
  }
}